import logo from './logo.svg';
import './App.css';
import Navbar from './components/Navbar';
import TextForm from './components/TextForm';
import About from './components/About';
import { useState } from 'react';
import Alert from './components/Alert';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";




function App() {
  // variables
  let tittle = "TextUtils";

  // hooks
  const [mode, setMode] = useState('light');
  const [alert, setAlert] = useState(null);



  // toggle mode
  const handleToggleMode = () => {
    if (mode === 'light') {
      setMode('dark');
      document.body.style.backgroundColor = '#01225b';
      showAlert('Dark mode Enabled!', 'success')
    }
    else {
      setMode('light');
      document.body.style.backgroundColor = 'white';
      showAlert('Light mode Enabled!', 'success')

    }
  }

  //alert
  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type
    });
    setTimeout(() => {
      setAlert(null);
    }, 1500);
  }

  return (
    <Router>
      <Navbar title={tittle} mode={mode} toggleMode={handleToggleMode} />
      <div style={{height:"40px"}}>
      <Alert exact alert={alert} />
      </div>
      <div className="container">
        <Switch>
          <Route exact path="/">
            <TextForm showAlert={showAlert} mode={mode} />
          </Route>
          <Route exact path="/Home">
            <TextForm showAlert={showAlert} mode={mode} />
          </Route>
          <Route exact path="/about" component={About} />
        </Switch>
      </div>
    </Router>
  );
}

export default App;
